/**
 * Pure helpers for org-board touch gestures (pan + pinch-zoom). Kept free of
 * Angular/DOM so the math is unit-testable; the component owns the listeners.
 */

/** Board zoom bounds — mirror the slider + zoomIn/zoomOut clamp in the board. */
export const OB_MIN_ZOOM = 0.15;
export const OB_MAX_ZOOM = 2.5;

export interface TouchPoint {
    clientX: number;
    clientY: number;
}

/** Clamp a zoom level into the board's supported range. */
export function clampZoom(level: number): number {
    if (level < OB_MIN_ZOOM) return OB_MIN_ZOOM;
    if (level > OB_MAX_ZOOM) return OB_MAX_ZOOM;
    return level;
}

/** Euclidean distance between two touch points (for pinch tracking). */
export function touchDistance(a: TouchPoint, b: TouchPoint): number {
    return Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY);
}

/**
 * New zoom level for a pinch: the gesture-start zoom scaled by the ratio of the
 * current finger distance to the start distance, clamped to the board range.
 * If the start distance is degenerate (≤0), the start zoom is returned unchanged
 * to avoid a divide-by-zero blow-up.
 */
export function zoomFromPinch(startZoom: number, startDist: number, currentDist: number): number {
    if (startDist <= 0) return startZoom;
    return clampZoom(startZoom * (currentDist / startDist));
}
